import { Controller } from "stimulus"
import videojs from "video.js"
import "video.js/dist/video-js.min.css"


export default class extends Controller {

  initialize() {
    this.element.classList.add("video-js")

    this.videojs = videojs(this.element, {
      preload: "auto",
      controls: true,
      fluid: true,
      responsive: true
    })

    this.videojs.on("ready", (event) => {
      console.log("player is ready")
    })
  }
}
